export const setMaxAndInterval = (maxValue) => {
  if (maxValue === 1 || maxValue === 2 || maxValue === 3 || maxValue === 4) {
    return { maxValue: maxValue, interval: 1 }
  } else if (maxValue % 3 === 0) {
    return { maxValue: maxValue, interval: maxValue / 3 }
  } else if (maxValue % 4 === 0) {
    return { maxValue: maxValue, interval: maxValue / 4 }
  } else {
    var newMaxValue = maxValue + (3 - (maxValue % 3))
    if (!newMaxValue) return { maxValue: 1, interval: 1 }
    return { maxValue: newMaxValue, interval: newMaxValue / 3 }
  }
}

export const chartColor = {
  Axis: '#D5DADF',
  Purple: '#9D74DF',
  LightblueZero: '#00A6CF',
  LightblueZeroFill: '#cff1f9',
  LightblueOne: '#256A7C',
  LightblueOne2: '#228eab',
  LightblueTwo: '#1E9DBE',
  LightblueThree: '#69CBE5',
  LightblueFour: '#98edc9',
  GialloDark: '#FFC31A',
  AcquamarineOne: '#39BA7C',
  AcquamarineOneFill: '#CFF8E4',
  AcquamarineTwoLight: '#98EDC9',
  AcquamarineTwo: '#8ACF61',
  AcquamarineThree: '#B0E2C9',
  Grey: '#DDDDDD',
  GreyDark: '#5D5D5D',
  YellowTwo: '#FFD356',
  YellowThree: '#EEA236',
  RedThree: '#FD7F75',
  DarkThree: '#CBCBCB',
  GreenOne: '#4ac184',
  GreenTwo: '#8ACF61',
}
